export default __webpack_public_path__ + "static/media/upi.8a6aa6f9.webp";